export default {
    // eslint-disable-next-line require-jsdoc
    data() {
        return {
            showChangelog: false,
        };
    },

    methods: {
        /**
         * Toggles changelog modal
         */
        toggleChangelogModal() {
            this.showChangelog = ! this.showChangelog;
        },
    },
};
